import AuthStore from './AuthStore'
import { observable, action, runInAction } from 'mobx'
import { RouterStore } from 'mobx-react-router'
import ContractStore from './ContractStore'
import SearchStore from './SearchStore'
import GraphStore from './GraphStore'
import UploadStore from './UploadStore'
import ApproveStore from './ApproveStore'
import PageStore from './PageStore'

// configure({ enforceActions: 'always' })
class Store {
    @observable public collapsed: boolean = false
    @observable public selectedKeys: string[] = ['']
    @observable public clientHeight: number = 0
    @observable public clientWidth: number = 0

    public authStore = new AuthStore()
    public contractStore = new ContractStore()
    public searchStore = new SearchStore()
    public graphStore = new GraphStore()
    public uploadStore = new UploadStore()
    public approveStore = new ApproveStore()
    public pageStore = new PageStore()
    public routing: RouterStore

    public constructor() {
        runInAction(() => {
            this.clientWidth = document.documentElement.clientWidth
            this.clientHeight = document.documentElement.clientHeight
        })
    }

    public clear() {
        this.collapsed = false
        this.selectedKeys = ['']
        this.authStore.clear()
        this.uploadStore.clear()
        this.approveStore.clear()
        this.searchStore.clear()
        this.contractStore.clear()
        this.graphStore.clear()
        this.pageStore.clear()
    }

    @action
    public toggleCollapse() {
        this.collapsed = !this.collapsed
    }

    @action
    public setSelectKeys(keys: string[]) {
        this.selectedKeys = keys
    }

    @action
    public resizeWindow(clientWidth: number, clientHeight: number) {
        this.clientWidth = clientWidth
        this.clientHeight = clientHeight
    }
}

export default new Store()
